export default {"src":"/_next/static/media/disconnect.c45c9b3a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};